import { StudentStore } from '../../../store/models/Store';
import { getCurrentItem } from '../../../store/selectors/getCurrentItem';
import { NoHotspotNotification as NoHotspotNotificationComponent } from '../components/NoHotspotNotification';
import { isNonSequencedFlowItem, Item } from '@ael/core-api';
import { connect } from 'react-redux';

const isCurrentlyNonSequencedFlowSelectedWithoutHotspots = (currentItem: Item | null) =>
  !!currentItem && isNonSequencedFlowItem(currentItem) && currentItem.hotspots.isEmpty();

function mapStateToProps(state: StudentStore) {
  const currentItem = getCurrentItem(state);
  const shouldDisplay = isCurrentlyNonSequencedFlowSelectedWithoutHotspots(currentItem);
  return {
    shouldDisplay,
  };
}

export const NoHotspotNotification = connect(mapStateToProps)(NoHotspotNotificationComponent);
